import { useContext } from "react";
import { IframeContextType } from "./types";
import { IframeContext } from "./provider";

export const usePersistentIframe = (): IframeContextType => {
  const context = useContext(IframeContext);
  if (!context) {
    throw new Error("useIframe must be used within an IframeProvider");
  }
  return context;
};
